var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeedling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2134 2134",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M266.667,400c515.416,0 933.333,417.917 933.333,933.333l0,600c0,36.667 -30,66.667 -66.667,66.667l-133.333,0c-36.667,0 -66.667,-30 -66.667,-66.667l0,-600c-515.416,0 -933.333,-417.916 -933.333,-933.333l266.667,-0Zm-0,40.914l-224.832,-0c21.388,473.836 412.388,851.506 891.498,851.506c22.596,-0 40.914,18.317 40.914,40.913l-0,600c-0,14.164 11.589,25.753 25.753,25.753l133.333,0c14.164,0 25.753,-11.589 25.753,-25.753l0,-600c0,-492.822 -399.597,-892.419 -892.419,-892.419Zm1600,-307.581l266.666,0c0,482.917 -366.666,879.584 -836.25,928.334c-45,-169.584 -130.416,-322.5 -245.833,-448.334c159.583,-286.25 464.583,-480 815.417,-480Zm-0,40.914c-325.121,-0 -609.059,174.044 -765.17,433.94c102.045,117.443 179.612,256.08 225.406,408.589c419.362,-59.871 745.131,-411.076 764.595,-842.529l-224.831,-0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeedling);
export default __webpack_public_path__ + "static/media/seedling.6e9b1d245e2013628a965ac219c5eea6.svg";
export { ForwardRef as ReactComponent };